export const AlertType = {
  // SUCESS: "Successfully Added",
  // UPDATED: "Successfully Updated",
  // DELETED: "Successfully Deleted",
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
  PRIMARY: "primary",
  SECONDARY: "secondary",
};
//define alert type response for toast message or any other alert
export const AlertResponse = {
  id: new Date().getTime(),
  type: "",
  message: "",
  // ShowHide: false,
  // AlertMessage: "",
  // AlertType: "",
  // BgColor: "",
  // TextClass: "",
  // TitleTextClass: "me-auto",
  // IsAutoHide: true,
};

export const AlertClass = {
  SUCESS: "",
  ERROR: "",
  WARNING: "",
  INFO: "",
  PRIMARY: "",
  SECONDARY: "",
  // SUCESS:'Success',
  // ERROR :'Danger',
  // WARNING:'Warning',
  // INFO :'Info',
  // PRIMARY:'Primary',
  // SECONDARY:'Secondary',
};

export const DisplayToastMessage = (toasts, setToasts, type, message) => {
  const newToast = {
    id: new Date().getTime(),
    type,
    message,
  };
  setToasts([...toasts, newToast]);
  // SetShowHideAlert((prevState) => ({
  //   ...prevState,
  //   ShowHide: true,
  //   AlertMessage: message,
  //   AlertType: type,
  // }));
};

// Function to add a new toast
export const addToast = (setToasts, type, message, autohide) => {
  console.log("addToast : ", type, message, autohide);
  if (message !== undefined || message !== "") {
    setToasts((prevToasts) => [
      ...(Array.isArray(prevToasts) ? prevToasts : []),
      {
        id: new Date().getTime(),
        type,
        message,
        autohide,
      },
    ]);
  }
};

export const addToastError = (setToasts, message, autohide) => {
  console.log("addToastError : ", setToasts, message, autohide);
  if (message !== undefined || message !== "") {
    addToast(setToasts, AlertType.ERROR, message, autohide);
  }
};
export const addToastSuccess = (setToasts, message, autohide) => {
  console.log("addToastSuccess : ", message, autohide);
  if (message !== undefined || message !== "") {
    addToast(setToasts, AlertType.SUCCESS, message, autohide);
  }
};
